<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@tixxSelect.sectionHeading.optionalCheckbox' class="esf-action-heading__text">Optional Checkbox</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              [disabled]="!(selectedLottery.isDraftMode || selectedLottery.isEditMode)"
              (click)="editSpecialRequirement();$event.stopPropagation();"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1">
  <div class="esf-info-tile__content"
       style="display: flex; height: 100%; flex-direction: column; justify-content: space-around;"
       *ngIf="!spinnerLoading">
    <ng-container *ngIf="!processConfiguration.specialRequirement">
      <section class="esf-empty-state flex-empty-state">
        <div>
          <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
            <use xlink:href="#esf-icon-check"></use>
          </svg>
        </div>
        <p class="esf-paragraph">
          <small i18n='Text for empty state@@customerOverviewComponent.text.optionalCheckboxNotActive'>Optional checkbox not active.</small>
        </p>
      </section>
    </ng-container>

    <ng-container *ngIf="processConfiguration.specialRequirement">
      <div class="esf-icon-and-text esf-icon-and-text--xs optional-checkbox-activated" *ngIf="processConfiguration.specialRequirement">
        <svg class="esf-icon" width="16" height="16">
          <use xlink:href="#esf-icon-circle-check"></use>
        </svg>
        <div class="esf-icon-and-text__text" i18n='@@tixxSelect.text.optionalCheckboxActivated'>Optional checkbox activated</div>
      </div>
      <div class="esf-icon-and-text esf-icon-and-text--xs optional-checkbox-description" *ngIf="selectedLottery.event.specialRequirementDescription">
        <svg class="esf-icon" width="16" height="16">
          <use xlink:href="#esf-icon-circle-check"></use>
        </svg>
        <div class="esf-icon-and-text__text" i18n='@@tixxSelect.text.optionalCheckboxTextProvided'>Optional checkbox text provided</div>
      </div>
      <div class="esf-icon-and-text esf-icon-and-text--xs optional-checkbox-text" *ngIf="selectedLottery.event.specialRequirementText">
        <svg class="esf-icon" width="16" height="16">
          <use xlink:href="#esf-icon-circle-check"></use>
        </svg>
        <div class="esf-icon-and-text__text" i18n='@@tixxSelect.text.optionalCheckboxContentProvided'>Optional checkbox content provided</div>
      </div>
    </ng-container>

  </div>

  <section class="esf-empty-state flex-empty-state" *ngIf="spinnerLoading">
    <app-spinner [name]="spinnerName" [(show)]="spinnerLoading"></app-spinner>
  </section>

</div>
